if (!customElements.get('mythk-mobile-vest-add')) {
  customElements.define('mythk-mobile-vest-add', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const form = dialog.querySelector('form');
      const select = form.querySelector('select');
      const submit = form.querySelector('[type="submit"]');
      this.querySelector('.mythk-mobile-vest-trigger').addEventListener('click', async () => {
        form.reset();
        submit.disabled = true;
        select.disabled = true;
        const errorElement = form.querySelector('.mythk-mobile-vest-error');
        errorElement.hidden = true;
        dialog.showModal();
        try {
          const response = await fetch(this.dataset.productUrl + '.js?country=ZA', { credentials: 'omit', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Product data unavailable');
          const data = await response.json();
          this.dataset.stockLoaded = 'true';
          for (const option of select.options) {
            const variant = data.variants.find(item => String(item.id) === option.value);
            if (!variant) continue;
            option.disabled = !variant.available;
            option.textContent = (variant.public_title || variant.title) + (variant.available ? '' : ' — ' + this.dataset.soldOut);
          }
        } catch (error) { this.dataset.stockLoaded = 'failed'; }
        select.disabled = false;

      });
      this.querySelector('.mythk-mobile-vest-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }});
      select.addEventListener('change', () => { submit.disabled = !select.value || select.selectedOptions[0].disabled; });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!select.value || select.selectedOptions[0].disabled || submit.disabled) return;
        submit.disabled = true;
        const errorElement = form.querySelector('.mythk-mobile-vest-error');
        errorElement.hidden = true;
        try {
          const response = await fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) {
            errorElement.textContent = this.dataset.country !== 'ZA' ? 'Impact vests cannot ship outside South Africa.' : (result.description || result.message || 'Unable to add this size. Please try again.');
            errorElement.hidden = false;
            submit.disabled = false;
            return;
          }
          window.location.assign(form.querySelector('[name="return_to"]').value);
        } catch (error) {
          errorElement.textContent = 'Unable to add this size. Please try again.';
          errorElement.hidden = false;
          submit.disabled = false;
        }
      });
    }
  });
}
if (!window.mythkVestPageStockInitialized) {
  window.mythkVestPageStockInitialized = true;
  const mobileStockMedia = window.matchMedia('(max-width:767px)');
  const initializeVestPageStock = () => {
    if (!mobileStockMedia.matches) return;
    document.querySelectorAll('[data-mythk-vest-stock-url]').forEach(async picker => {
      if (picker.dataset.mythkStockLoading) return;
      picker.dataset.mythkStockLoading = 'true';
      try {
        const response = await fetch(picker.dataset.mythkVestStockUrl + '.js?country=ZA', { credentials:'omit', headers:{ Accept:'application/json' } });
        if (!response.ok) throw new Error('Product data unavailable');
        const product = await response.json();
        const productArea = picker.closest('.productView-product');
        const syncStock = () => {
          if (!mobileStockMedia.matches) return;
          for (const label of picker.querySelectorAll('label[data-variant-id]')) {
            const variant = product.variants.find(item => String(item.id) === label.dataset.variantId);
            if (!variant) continue;
            const available = String(variant.available);
            if (label.dataset.mythkAvailable !== available) label.dataset.mythkAvailable = available;
            if (variant.available && label.classList.contains('soldout')) label.classList.remove('soldout');
            if (variant.available && !label.classList.contains('available')) label.classList.add('available');
            if (!variant.available && label.classList.contains('available')) label.classList.remove('available');
            if (!variant.available && !label.classList.contains('soldout')) label.classList.add('soldout');
          }
          const selected = picker.querySelector('input.product-form__radio:checked');
          const variant = selected && product.variants.find(item => String(item.id) === selected.dataset.variantId);
          if (productArea && variant) {
            const available = String(variant.available);
            if (productArea.dataset.mythkSelectedInStock !== available) productArea.dataset.mythkSelectedInStock = available;
          }
        };
        syncStock();
        picker.addEventListener('change', syncStock);
        const observer = new MutationObserver(syncStock);
        observer.observe(picker, { subtree:true, attributes:true, attributeFilter:['class'], childList:true });
        mobileStockMedia.addEventListener('change', event => {
          if (event.matches) { syncStock(); return; }
          for (const label of picker.querySelectorAll('label[data-mythk-available]')) {
            const variant = product.variants.find(item => String(item.id) === label.dataset.variantId);
            const contextual = picker.querySelector('script[type="application/json"]');
            const variants = contextual ? JSON.parse(contextual.textContent) : [];
            const original = variants.find(item => String(item.id) === label.dataset.variantId);
            if (original) { label.classList.toggle('soldout', !original.available); label.classList.toggle('available', original.available); }
          }
        });
      } catch (error) { delete picker.dataset.mythkStockLoading; }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeVestPageStock);
  else initializeVestPageStock();
  mobileStockMedia.addEventListener('change', initializeVestPageStock);
}


if (!customElements.get('mythk-mobile-vest-purchase')) {
  customElements.define('mythk-mobile-vest-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const area = this.closest('.productView-product');
      const media = window.matchMedia('(max-width:767px)');
      const sync = () => {
        const selected = area.querySelector('[data-mythk-vest-stock-url] input.product-form__radio:checked');
        const variant = this.productData?.variants.find(item => String(item.id) === selected?.dataset.variantId);
        form.elements.id.value = variant ? String(variant.id) : '';
        for (const button of buttons) button.disabled = this.busy || !variant?.available;
      };
      const loadStock = async () => {
        if (!media.matches || this.productData || this.loading) return;
        this.loading = true;
        try {
          const response = await fetch(this.dataset.productUrl + '.js?country=ZA', { credentials:'omit', headers:{ Accept:'application/json' } });
          if (!response.ok) throw new Error('Product data unavailable');
          this.productData = await response.json();
          sync();
        } catch (error) {
          const message = form.querySelector('[role="alert"]');
          message.textContent = this.dataset.cartError;
          message.hidden = false;
        } finally { this.loading = false; }
      };
      area.addEventListener('change', sync);
      media.addEventListener('change', loadStock);
      loadStock();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!media.matches || this.busy || !form.elements.id.value || !form.reportValidity()) return;
        const selected = this.productData?.variants.find(item => String(item.id) === form.elements.id.value);
        if (!selected?.available) return;
        const buyNow = event.submitter?.hasAttribute('data-buy-now');
        const error = form.querySelector('[role="alert"]');
        error.hidden = true;
        this.busy = true;
        sync();
        try {
          const response = await fetch(form.action + '.js', { method:'POST', body:new FormData(form), headers:{ Accept:'application/json' } });
          const result = await response.json();
          if (!response.ok) {
            error.textContent = this.dataset.country !== 'ZA' ? this.dataset.shippingError : (result.description || result.message || this.dataset.cartError);
            error.hidden = false;
            this.busy = false;
            sync();
            return;
          }
          const cartUrl = form.action.slice(0, -4);
          window.location.assign(buyNow ? cartUrl + '/checkout' : cartUrl);
        } catch (failure) {
          error.textContent = this.dataset.cartError;
          error.hidden = false;
          this.busy = false;
          sync();
        }
      });
    }
  });
}
